import React from 'react';
import styled from 'styled-components';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Icon } from 'antd';
import {
  WhiteFour,
  WarmGrey,
  GreyishBrown,
  NiceBlue
} from '../../styles/Colours';
import Transition from 'react-transition-group/Transition';
import ClickOutsideComponent from '../../components/ClickOutside/ClickOutsideComponent';
import { updateProfile } from '../../redux/user/user.actions';
import DefaultCheckbox from '../../components/Inputs/DefaultCheckbox';
import * as UsersService from '../../services/UsersService';

const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(34, 34, 34, 0.5);
  transition: all 0.2s ease;
  opacity: ${props => (props.state === 'entered' ? '1' : '0')};
  overflow-y: auto;
  z-index: 9999;
`;

const Modal = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 700px;
  max-width: 100%;
  background: ${WhiteFour};
  padding: 35px 20px;
  transform-origin: center;
  transition: all 0.2s ease;
  transform: ${props =>
    props.state === 'entered'
      ? 'translate(-50%, -50%) scale(1)'
      : 'translate(-50%, -50%) scale(0)'};
`;

const CloseButton = styled.div`
  position: absolute;
  top: 35px;
  right: 20px;
  font-size: 30px;
  color: ${WarmGrey};
  cursor: pointer;
`;

const ModalTitle = styled.div`
  font-size: 20px;
  color: ${GreyishBrown};
  font-weight: bold;
  line-height: 1.5;
  margin-bottom: 50px;
`;

const ModalButton = styled.div`
  float: right;
  margin-top: 20px;
  background: ${NiceBlue};
  color: ${WhiteFour};
  text-align: center;
  padding: 8px;
  border-radius: 3px;
  cursor: pointer;
`;

const Content = styled.div`
  margin: 20px 0;
  font-size: 16px;
`;

class NewUpdatesModal extends React.Component {
  state = {
    no_notify: false
  };

  updateProfile() {
    const { user, updateProfile } = this.props;
    const { no_notify } = this.state;
    user.profile.read_updates = 1;
    updateProfile(user.profile);
    if (no_notify) UsersService.readUpdates();
  }

  handleClose = () => {
    this.updateProfile();
  };

  showUpdates = () => {
    const { history } = this.props;
    this.updateProfile();
    history.push('/profile?categories=true');
  };

  render() {
    const { user } = this.props;
    const { no_notify } = this.state;
    const showModal =
      user && user.profile && user.profile.read_updates === false;
    return (
      <Transition
        timeout={{ enter: 0, exit: 200 }}
        in={showModal}
        unmountOnExit
        mountOnEnter
      >
        {state => (
          <ModalBackdrop state={state}>
            <ClickOutsideComponent callback={this.handleClose}>
              <Modal state={state}>
                <CloseButton onClick={this.handleClose}>
                  <Icon type="close" theme="outlined" />
                </CloseButton>
                <ModalTitle>New updates released</ModalTitle>
                <Content>
                  To help RRN users identify fellow members and arrange
                  collaborations please select the categories which best
                  describe your major research interests
                </Content>
                <DefaultCheckbox
                  input={{
                    value: no_notify,
                    onChange: () => this.setState({ no_notify: !no_notify })
                  }}
                  label="Don't show this message again"
                />
                <ModalButton onClick={this.showUpdates}>
                  Choose Categories
                </ModalButton>
              </Modal>
            </ClickOutsideComponent>
          </ModalBackdrop>
        )}
      </Transition>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.user
});

const mapActionToProps = dispatch =>
  bindActionCreators({ updateProfile }, dispatch);

export default withRouter(
  connect(
    mapStateToProps,
    mapActionToProps
  )(NewUpdatesModal)
);



// WEBPACK FOOTER //
// ./src/components/NewUpdateModal/NewUpdateModal.js